import confettiAnimatioin from '../../assets/lottie/confetti.json';

export const animations = {
  list: {
    data: confettiAnimatioin,
    name: 'Confetti Animation',
    description: 'Animation for empty list states'
  },
};

export default animations; 